import { render, staticRenderFns } from "./MyInfoDextUploader.vue?vue&type=template&id=04efb1f5"
import script from "./MyInfoDextUploader.vue?vue&type=script&lang=js"
export * from "./MyInfoDextUploader.vue?vue&type=script&lang=js"
import style0 from "./MyInfoDextUploader.vue?vue&type=style&index=0&id=04efb1f5&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04efb1f5')) {
      api.createRecord('04efb1f5', component.options)
    } else {
      api.reload('04efb1f5', component.options)
    }
    module.hot.accept("./MyInfoDextUploader.vue?vue&type=template&id=04efb1f5", function () {
      api.rerender('04efb1f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/MyInfoDextUploader.vue"
export default component.exports